// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-avneue-no-vendor -> repli-sandbox-avneue-no-vendor -> jackstraw-apartments-978e
// Generated: 2026-10-05T18:31:18.789Z
// Counts: 1 design, 13 content, 18 slot group, 0 collection binding, 3 section, 0 style

export const designOverrides = {
  "design._site.color.primary": {
    "cssVariable": "--vibe-color-primary",
    "overrideType": "VALUE",
    "value": "#0095ff",
    "mappedField": null
  }
};

export const contentOverrides = {
  "apartment-sync.javascript_id": {
    "overrideType": "VALUE",
    "customValue": "asdfasdfasdf",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "110 Royyyyy",
    "generatedValue": null,
    "mappedField": null
  },
  "featuredamenities.apartmentBlurbSubtitle": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Polished finishes and thoughtful details</p>",
    "mappedField": null
  },
  "featuredamenities.apartmentBlurbText": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Step inside to quartz countertops, stainless steel appliances, and floor-to-ceiling windows that pull in the Cascade light. Custom closets and in-home laundry keep daily life easy, while cleaner air and select mountain views make every layout feel considered. It's a space designed to live well in, day after day.</p>",
    "mappedField": null
  },
  "featuredamenities.apartmentBlurbTitle": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>A Home That Feels Right</p>",
    "mappedField": null
  },
  "featuredamenities.communityBlurbSubtitle": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Shared spaces built for Central Oregon living</p>",
    "mappedField": null
  },
  "featuredamenities.communityBlurbText": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>From the double-height fitness center to the fifth-floor Sunset Lounge, every shared space at Jackstraw is designed to bring the outside in. Slip into a private office for focused work, meet friends in the courtyard, or treat your dog to the pet spa. This is a community that flows as easily as a day in Bend.</p>",
    "mappedField": null
  },
  "featuredamenities.communityBlurbTitle": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Gather, Work, Unwind</p>",
    "mappedField": null
  },
  "gallery.apartment_blurb": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>From smart studios to three-bedroom and townhome-style layouts, every Jackstraw home is designed around light, air, and storage. Expect quartz countertops with tile backsplashes, stainless steel appliances, in-home laundry, custom closets, and floor-to-ceiling windows—many with private balconies or select Cascade Mountain views.</p>",
    "mappedField": null
  },
  "gallery.community_blurb": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Life at Jackstraw spills out beyond your front door into spaces built for connection—a double-height fitness center, private offices and conference rooms, and the fifth-floor Sunset Lounge with its Cascade views. Landscaped courtyards, a resident lobby, a pet spa, and 60+ EV chargers round out a Fitwel-certified community set in Bend's Southern Crossing.</p>",
    "mappedField": null
  },
  "hero.learn_more": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Set in Bend's Southern Crossing between downtown and the Old Mill District, Jackstraw offers studio, one-, two-, and three-bedroom apartments plus townhome-style layouts with quartz countertops, stainless appliances, in-home laundry, and select Cascade Mountain views. Days flow from the double-height fitness center to private offices, the fifth-floor Sunset Lounge, courtyards, and a pet spa, with 60+ EV chargers and Fitwel-certified design throughout. Step outside to Sisters Coffee, Market of Choice, riverfront dining, and the Deschutes River Trail's Old Mill Reach.</p>",
    "mappedField": null
  },
  "hero.romance_blurb": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>At Jackstraw, life in Bend begins the moment you step outside your door. This mixed-use address in Southern Crossing pairs light-filled, well-storied homes with a walkable setting between downtown and the Old Mill District — a polished home base for the best of Central Oregon, whether your weekend runs toward the river trail, the amphitheater, or a slow morning coffee.</p><ul><li>A range of <a href=\"/floor-plans\">floor plans</a> from smart studios to three-bedroom and townhome-style layouts</li><li>Standout <a href=\"/amenities\">community amenities</a> designed for work, wellness, and connection</li><li>A connected <a href=\"/neighborhood\">Southern Crossing neighborhood</a> beside shops, dining, and the Deschutes River</li><li>Fitwel-certified, sustainably designed living with 60+ EV chargers</li><li>Homes made for your active lifestyle, with bike racks in every unit</li></ul>",
    "mappedField": null
  },
  "petpolicy.intro": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>At Jackstraw, your whole family is welcome—four legs included. With an on-site pet spa, landscaped courtyards, and the Deschutes River Trail just steps away, Bend's dog-loving, outdoor lifestyle is right outside your door.</p>",
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "amenitycardgrid.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-1b27-70bc-a3b8-35e73199f1c1.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Bright gym interior with treadmills, weight racks, and large windows."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Fitness Center"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Fuel your active Bend lifestyle in a light-filled, double-height fitness center with free weights, cardio, and functional training space — a full workout without ever leaving home."
      }
    }
  },
  "amenitycardgrid.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-c4c4-755e-a1b5-4b15f321bd82.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern apartment community lounge with blue couches, wooden tables, wall art, and large windows."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Lounge"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Gather with neighbors or unwind solo in the fifth-floor Sunset Lounge, where comfortable seating and floor-to-ceiling windows frame golden-hour views of the city and mountains."
      }
    }
  },
  "amenitycardgrid.card_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-b871-73df-8111-8bea4b444a75.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern community lounge with a long table, black pendant lights, and seating; people visible in the background."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Club Room"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Host a dinner, spread out to work, or simply linger over coffee in a bright club room built for connection, complete with a communal table and kitchenette."
      }
    }
  },
  "amenitycardgrid.card_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-20ec-74ac-8bd4-cf3d07f29bd6.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Bike storage area with multiple wall-mounted racks on a plywood wall and a bicycle."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Bike Racks in Every Home"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Bend is a two-wheel town, and every home comes ready for it. Dedicated bike storage keeps your gear secure and the Deschutes River Trail always within reach."
      }
    }
  },
  "amenitycardgrid.card_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-cef0-72cf-8edb-5bb004c6fa12.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Walk-in closet with white walls, hanging rods, shelves, and clothing on hangers"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Custom Closets with Extra Room"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Stay effortlessly organized with custom closets offering generous shelving and hanging space — room for your ski gear, work wardrobe, and everything in between."
      }
    }
  },
  "ctasection.card1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-0e68-72b9-a201-070fbe222ed7.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Contemporary living room with wall sculpture, vinyl setup, and glass door to sunlit balcony."
      }
    }
  },
  "ctasection.card2_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-a96d-770a-b340-afe3f86547fc.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior entrance of a modern apartment building with glass doors and landscaped walkway."
      }
    }
  },
  "ctasection.card3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-c96e-759f-8ec2-a58352d2e5e8.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Balcony view of a town with trees and distant mountains under a blue sky."
      }
    }
  },
  "ctasection.card4_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-2e7f-72a9-9ddd-3cedbdf4c122.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Evening view of a modern apartment courtyard with seating and orange umbrellas."
      }
    }
  },
  "gallery.hero_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-385e-712e-b782-f79132bcb078.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of a modern apartment complex with multiple buildings, parking lots, and distant mountains."
      }
    }
  },
  "gallery.hero_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-973b-748b-bc5c-5f6af8beeb5a.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Two-story living room with large windows, white walls, and a brown sectional sofa."
      }
    }
  },
  "gallery.hero_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-c4c4-755e-a1b5-4b15f321bd82.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern apartment community lounge with blue couches, wooden tables, wall art, and large windows."
      }
    }
  },
  "petpolicy.feature_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-2e7f-72a9-9ddd-3cedbdf4c122.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Evening view of a modern apartment courtyard with seating and orange umbrellas."
      }
    }
  },
  "petpolicy.lifestyle_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-a96d-770a-b340-afe3f86547fc.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior entrance of a modern apartment building with glass doors and landscaped walkway."
      }
    }
  },
  "propertyoverview.feature_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-385e-712e-b782-f79132bcb078.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of a modern apartment complex with multiple buildings, parking lots, and distant mountains."
      }
    }
  },
  "propertyoverview.feature_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-973b-748b-bc5c-5f6af8beeb5a.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Two-story living room with large windows, white walls, and a brown sectional sofa."
      }
    }
  },
  "propertyoverview.feature_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-bbe9-70b0-a3eb-f02c03dd2aaf.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Interior community lounge with wood-paneled walls, framed art, and a long table with green chairs."
      }
    }
  },
  "propertyoverview.feature_image_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166986/019cfde3-8b34-721b-9ab6-9f2bfc5b8b6e.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Bright open-concept kitchen with stainless steel appliances, an island, and a marble dining table."
      }
    }
  }
};

export const collectionBindingOverrides = {};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    }
  ],
  "floor-plans": [
    {
      "sectionId": "apartment-sync",
      "blockId": "apartment-sync",
      "position": 3
    }
  ]
};

export const styleOverrides = {};
